class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn =
          (this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : null) ||
          document.getElementById('CartDrawer') ||
          this;
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (!containerToTrapFocusOn) return;
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    // La classe `is-empty` est portée par <cart-drawer>, pas par .drawer__inner.
    // On nettoie sur les deux par précaution (theme legacy peut varier).
    this.classList.remove('is-empty');
    const inner = this.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


/* TILT — Resync cart drawer sur retour arrière (bfcache OU back-nav classique).
   Quand l'utilisateur ajoute un produit puis navigue ailleurs, puis clique
   "précédent", le cart drawer de la page précédente peut être obsolète
   (restauré depuis le bfcache, ou rechargé depuis un cache HTTP classique).
   On détecte les 2 cas et on refresh silencieusement le drawer. */
(function () {
  var lastSyncedCount = null;

  function refreshCartDrawer(reason) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    console.log('[TILT Cart] refresh drawer —', reason);

    var sectionsToRender =
      typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender()
        : [
            { id: 'cart-drawer', selector: '#CartDrawer' },
            { id: 'cart-icon-bubble' },
          ];
    var sectionIds = sectionsToRender.map(function (s) { return s.id; }).join(',');

    fetch('/?sections=' + sectionIds, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        sectionsToRender.forEach(function (section) {
          var el = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          if (!el || !sections[section.id]) return;
          var html =
            typeof cartDrawer.getSectionInnerHTML === 'function'
              ? cartDrawer.getSectionInnerHTML(sections[section.id], section.selector)
              : sections[section.id];
          el.innerHTML = html;
        });
      })
      .then(function () {
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        lastSyncedCount = cart.item_count;
        if (cart.item_count === 0) cartDrawer.classList.add('is-empty');
        else cartDrawer.classList.remove('is-empty');

        /* Compteur custom TILT dans le header (pas rendu via section cart-icon-bubble) */
        document.querySelectorAll('.tilt-nav__cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
        /* Compteur standard Shopify au cas où il est aussi présent */
        document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function (err) {
        console.warn('[TILT Cart] refresh failed', err);
      });
  }

  /* Cas 1 : bfcache restored (persisted=true) */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      refreshCartDrawer('bfcache restore');
      return;
    }
    /* Cas 2 : navigation back/forward classique (reload depuis HTTP cache).
       On vérifie via Performance Navigation Timing. */
    try {
      var navEntry = performance.getEntriesByType('navigation')[0];
      if (navEntry && navEntry.type === 'back_forward') {
        refreshCartDrawer('back_forward nav');
      }
    } catch (e) {}
  });

  /* Cas 3 : filet de sécurité — quand l'onglet redevient visible, si le
     compteur serveur a changé vs notre dernier sync, on rafraîchit. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (lastSyncedCount !== null && cart.item_count !== lastSyncedCount) {
          refreshCartDrawer('visibility + count drift');
        } else if (lastSyncedCount === null) {
          lastSyncedCount = cart.item_count;
        }
      })
      .catch(function () {});
  });
})();
